export default __webpack_public_path__ + "static/media/330_portfolio02-en-mobile.b00d22ee.png";